export default {
  palette: {
    primary1Color: '#F2755F',
    primary2Color: '#FFA48D',
    primary3Color: '#f3755f'
  }
}



// WEBPACK FOOTER //
// ./src/themes/custom.js